export const FOOTER_TEST_ID = 'command-palette.ui.modal.footer.footer';
